module.exports = __webpack_public_path__ + "img/epr-article-top-img_small.2ff27541.jpg";